import { render } from "./DynamicMarketingChannels.vue?vue&type=template&id=6bb60ada&scoped=true"
import script from "./DynamicMarketingChannels.vue?vue&type=script&lang=js"
export * from "./DynamicMarketingChannels.vue?vue&type=script&lang=js"

import "./DynamicMarketingChannels.vue?vue&type=style&index=0&id=6bb60ada&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb60ada"]])

export default __exports__